import {
  PLAN_ORDER_REPORT_PROCESS_ADDED,
  PLAN_ORDER_REPORT_PROCESS_DELETED,
  PLAN_ORDER_REPORT_PROCESS_EDITED,
  PLAN_ORDER_REPORT_PROCESS_SET,
} from 'src/app/redux/redux-types';
import { reduxPlanOrderReportProcessTypes } from 'src/types';

export const planOrderReportProcessDefaultState: reduxPlanOrderReportProcessTypes.StateType = {
  planOrderReportProcessList: [],
};

export const planOrderReportProcessReducer = (
  state = planOrderReportProcessDefaultState,
  action: reduxPlanOrderReportProcessTypes.ActionType,
): reduxPlanOrderReportProcessTypes.StateType => {
  switch (action.type) {
    case PLAN_ORDER_REPORT_PROCESS_SET:
      return {
        ...state,
        planOrderReportProcessList: action.payload,
      };
    case PLAN_ORDER_REPORT_PROCESS_ADDED:
      const exists = state.planOrderReportProcessList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        planOrderReportProcessList: [action.payload, ...state.planOrderReportProcessList],
      };
    case PLAN_ORDER_REPORT_PROCESS_EDITED:
      const updateIndex = state.planOrderReportProcessList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        planOrderReportProcessList: [
          ...state.planOrderReportProcessList.slice(0, updateIndex),
          action.payload,
          ...state.planOrderReportProcessList.slice(updateIndex + 1),
        ],
      };
    case PLAN_ORDER_REPORT_PROCESS_DELETED:
      return {
        ...state,
        planOrderReportProcessList: state.planOrderReportProcessList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
